import { render, staticRenderFns } from "./cameraDetailForm.vue?vue&type=template&id=27520e54&scoped=true&"
import script from "./cameraDetailForm.vue?vue&type=script&lang=js&"
export * from "./cameraDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./cameraDetailForm.vue?vue&type=style&index=0&id=27520e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27520e54",
  null
  
)

export default component.exports